import { Modal, ModalBody, ModalFooter } from "reactstrap";
import TimeZone from "../../CustomHooks/TimeZone";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import API from "../../Network/API";
import { format } from 'date-fns';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function EditMeeting(props) {
    const [check_box,setCheckbox]=useState(false)
    const [time_zone, setTimeZone] = useState('Europe/London');
    const [time, setTime] = useState(null);
    const [note, setNote] = useState(props?.meetingRoom?.note || '');
    const usert_timez = useSelector((state) => state.timeZoneReducer)
    const [timezonename, setTimezoneText] = useState('');
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        if (props?.meetingRoom) {
            setNote(props.meetingRoom.note || '');
        }
    }, [props?.meetingRoom]);

    const getCurrentTimezone = () => {
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setTimezoneText(userTimezone);
    };
    const fileObj = [];

    const handleSubmit = event => {
        event.preventDefault();
        if (typeof title === null) {
            toast.error('Please add title.');
            return false;
        }
        if (typeof time_zone === null) {
            toast.error('Please add time_zone.');
            return false;
        }
        const fd = new FormData();
        fd.append('title', event.target.title.value);
        fd.append('date', event.target.date.value);
        fd.append('time_zone', event.target.time_zone.value);
        fd.append('time', event.target.time.value);
        fd.append('note', note);
       if(event.target.is_notify.checked){
         fd.append('is_notify', 1);
       }
       if(event.target.is_recurring.checked){
        fd.append('is_repeated', 1);
  
        if(event.target.recurring_type.value==""){
          alert("Please select recurrence type");
          return;
        }
        fd.append('recurring_type', event.target.recurring_type.value);
  
      }else{
        fd.append('is_repeated', 0);
        fd.append('recurring_type', 0);
      }

        setLoading(true);
        if (fileObj.length > 0) {
            for (var i = 0; i < fileObj.length; i++) {
                fd.append('img', fileObj[i], fileObj[i].name);
            }
        }

        API.post(`/v3/meeting/update/${props?.meetingRoom?.id}`, fd).then(response => {
            setLoading(false);
            if (response.data.success === true) {
                props.handleShowB()
            }
        }).catch((error) => {
            setLoading(false);
            toast.error(error.response.data.sms);
        });
    }

    const uploadHandler = (e) => {
        fileObj.pop();
        fileObj.push(e.target.files[0])
    }
    const startDate = new Date(props?.meetingRoom?.start_date);
    const formattedDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`;
    return (
        <>
            <Modal
                isOpen={props.isModalVisible}
                size=""
                scrollable={false}
                toggle={props.handleShowB}
                className={'modal-dialog'} backdrop="static"
            >
                <div className="modal-header border-0 pb-2">
                    <h5 className="modal-title fw-bold text-dark mb-0">Edit Meeting</h5>
                    <button type="button" className="btn-close" onClick={props.handleShowB} aria-label="Close"></button>
                </div>
                <ModalBody className="bg-white px-4 py-0">

                    <div className="meeting-schedule-popup">
                        <form onSubmit={handleSubmit}>
              <div className="py-3">
                
                {/* TITLE */}
                <div className="mb-4">
                  <label htmlFor="Title" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                    Meeting Title
                  </label>
                  <input 
                    type="text" 
                    defaultValue={props?.meetingRoom?.room_title} 
                    name="title" 
                    className="form-control form-control-lg border rounded-3 px-3 shadow-none" 
                    id="Title" 
                    placeholder="Enter your meeting name" 
                    style={{fontSize: '15px', color: '#334155'}}
                    required 
                  />
                </div>

                {/* DATE / TIME GRID */}
                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <label htmlFor="date" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                      Date
                    </label>
                    <input 
                      type="date" 
                      defaultValue={formattedDate} 
                      name="date" 
                      onChange={(e) => {
                          if (e.target.value) {
                              const timeInput = document.getElementById('time');
                              if (timeInput) {
                                  timeInput.focus();
                                  try { if (typeof timeInput.showPicker === 'function') timeInput.showPicker(); } catch (err) {}
                              }
                          }
                      }}
                      onBlur={(e) => {
                          if (e.target.value) {
                              const timeInput = document.getElementById('time');
                              if (timeInput && document.activeElement === document.body) timeInput.focus();
                          }
                      }}
                      className="form-control form-control-lg border rounded-3 px-3 shadow-none" 
                      id="date" 
                      style={{fontSize: '15px', color: '#334155'}}
                      required 
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="time" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                      Start Time
                    </label>
                    <input 
                      type="time" 
                      defaultValue={props?.meetingRoom?.start_time} 
                      name="time" 
                      className="form-control form-control-lg border rounded-3 px-3 shadow-none" 
                      id="time" 
                      style={{fontSize: '15px', color: '#334155'}}
                      required 
                    />
                  </div>
                </div>

                {/* TIMEZONE */}
                <div className="row g-3 mb-4">
                  <div className="col-md-12">
                    <label htmlFor="inputState" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                      Time Zone
                    </label>
                    <select
                      id="inputState"
                      name="time_zone"
                      defaultValue={props?.meetingRoom?.time_zone}
                      className="form-select form-select-lg border rounded-3 px-3 shadow-none"
                      style={{fontSize: '15px', color: '#334155'}}
                      required
                    >
                      {TimeZone()?.map((zoneName, index) => (
                        <option
                          key={index}
                          value={zoneName}
                          selected={props?.meetingRoom?.time_zone === zoneName}
                        >
                          {zoneName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* TOGGLES: Recurring & Notifications */}
                <div className="d-flex flex-column gap-3 mb-4">
                  
                  {/* Notifications Toggle */}
                  <div className="d-flex align-items-center justify-content-between border rounded-4 p-3 shadow-sm bg-white" style={{ borderColor: '#e2e8f0' }}>
                    <div>
                      <h6 className="mb-1 fw-bold text-dark" style={{fontSize: '14px'}}>Notify Users</h6>
                      <p className="mb-0 text-secondary" style={{fontSize: '13px'}}>
                        Send an update notification to all invited participants.
                      </p>
                    </div>
                    <div className="form-check form-switch m-0 pt-0 pe-2">
                        <input 
                            name="is_notify" 
                            type="checkbox" 
                            role="switch"
                            className="form-check-input m-0 custom-switch float-end" 
                            id="is_notify_enabled" 
                            style={{transform: 'scale(1.2)', cursor: 'pointer' }}
                        />
                    </div>
                  </div>

                  {/* Recurring Toggle */}
                  <div className="d-flex flex-column border rounded-4 p-3 shadow-sm bg-white" style={{ borderColor: '#e2e8f0' }}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="mb-1 fw-bold text-dark" style={{fontSize: '14px'}}>Recurring Meeting</h6>
                        <p className="mb-0 text-secondary" style={{fontSize: '13px'}}>Repeat this meeting daily, weekly, or monthly.</p>
                      </div>
                      <div className="form-check form-switch m-0 pt-0 pe-2">
                        <input 
                          onChange={()=>setCheckbox(!check_box)} 
                          type="checkbox" 
                          role="switch"
                          className="form-check-input m-0" 
                          id="is_recurring" 
                          name="is_recurring"
                          style={{transform: 'scale(1.2)', cursor: 'pointer', backgroundColor: check_box ? '#1e293b' : '' }}
                        />
                      </div>
                    </div>
                    {check_box && (
                      <div className="mt-3 pt-3 border-top">
                        <label className="form-label fw-semibold text-dark mb-2" style={{fontSize: '13px'}}>How often?</label>
                        <select 
                          className="form-select border rounded-3 px-3 shadow-none" 
                          name="recurring_type" 
                          id="recurring_type"
                          style={{fontSize: '14px', maxWidth: '300px'}}
                        >
                          <option value="">Select frequency</option>
                          <option value={1}>Daily</option>
                          <option value={2}>Weekly</option>
                          <option value={3}>Monthly</option>
                        </select>
                      </div>
                    )}
                  </div>
                </div>

                {/* AGENDA */}
                <div className="mb-4">
                  <label htmlFor="Description" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                    Agenda & Notes
                  </label>
                  <div className="border rounded-3 overflow-hidden shadow-sm">
                    <ReactQuill
                      theme="snow"
                      id="Description"
                      value={note}
                      onChange={setNote}
                      placeholder="Add meeting agenda, notes, or description (optional)"
                      className="bg-white border-0"
                      style={{ fontSize: '15px' }}
                      modules={{
                        toolbar: [
                          ['bold', 'italic', 'underline'],
                          [{ 'list': 'bullet' }, { 'list': 'ordered' }]
                        ]
                      }}
                      formats={[
                        'bold', 'italic', 'underline', 'list', 'bullet'
                      ]}
                    />
                  </div>
                </div>
              </div>
              
              <ModalFooter className="border-top pt-4 px-4 pb-4">
                <div className="d-flex justify-content-end gap-3 w-100">
                  <button 
                    type="button" 
                    onClick={props.handleShowB}
                    className="btn btn-outline-secondary rounded-pill px-4 py-2 bg-transparent"
                    style={{fontSize: '14px', fontWeight: '600', color: '#64748b', border: 'none'}}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-dark rounded-pill px-4 py-2 text-white shadow-sm d-flex align-items-center"
                    style={{fontSize: '14px', fontWeight: '600', transition: 'all 0.2s', backgroundColor: '#0f172a'}}
                    disabled={loading}
                    onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
                    onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" style={{width: '14px', height: '14px'}}></span>
                        Updating...
                      </>
                    ) : (
                      <>
                        <i className="fa-solid fa-save me-2" style={{fontSize: '13px', opacity: 0.9}}></i>
                        Update Meeting
                      </>
                    )}
                  </button>
                </div>
              </ModalFooter>
            </form>
                    </div>

                </ModalBody>
            </Modal>
        </>
    )
}